import { useState, useEffect } from 'react'
import { useSequencedFormData } from '../SequencedFormDataProvider'
import { getDataOptions } from '../helpers'

withDerivedData = ({
  queries,
  derivedData
}) ->

  [initting, setInitting] = useState(true)
  [options, setOptions] = useState([])
  [{ formData }] = useSequencedFormData()

  useEffect(->
    (->
      setOptions(
        (await getDataOptions(queries, derivedData, formData)) or []
      )
      setInitting(false)
    )()
    undefined
  , [formData])

  { options, initting }

export default withDerivedData